export const saveHasCompletedCVStorage = (hasCompleteCV) => {
    if (typeof localStorage === 'undefined')
        return;
    localStorage.setItem('hasCompleteCV', hasCompleteCV.toString());
};
export const saveLastLoginMethod = (method) => {
    if (typeof localStorage === 'undefined')
        return;
    try {
        localStorage.setItem('lastLoginMethod', String(method));
    }
    catch (error) {
        console.error(`Failed to save last login method with error: ${error}`);
    }
};
export const getLastLoginMethod = () => {
    if (typeof localStorage === 'undefined')
        return null;
    return localStorage.getItem('lastLoginMethod');
};
//# sourceMappingURL=storage.js.map